<template>
  <span class="badge-first-visit">
    {{ $t('common.ui.firstVisit') }}
  </span>
</template>

<script>
export default {
  name: 'badge-first-visit'
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.badge-first-visit {
  background: lighten($color-success, 52.5%);
  border: 1px solid $color-success;
  border-radius: $border-radius-small;
  color: $color-success;
  display: inline-block;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: .025rem;
  line-height: 1.6rem;
  padding: .125rem .5rem;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BadgeFirstVisit.vue